import React from "react";
import { Link as LinkComponent } from "iparque-components";

interface Props {
  href: string;
  ariaLabel?: string;
  target?: string;
  className?: string;
}

const Link: React.FC<Props> = ({
  href,
  ariaLabel,
  target = "_blank",
  className = "",
  children,
}) => {
  return (
    <LinkComponent
      underline="always"
      target={target}
      aria-label={ariaLabel}
      href={href}
      rel="noopener"
      className={className}
    >
      {children}
    </LinkComponent>
  );
};

export default Link;
